import { ComponentType } from '@angular/cdk/portal'
import { Injectable, TemplateRef } from '@angular/core'
import { take } from 'rxjs/operators'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { DiscountCodeDialogComponent } from './discount-code-dialog.component'
import { DiscountCode } from '@tokeet-frontend/discount-codes'

@Injectable({ providedIn: 'root' })
export class DiscountCodeDialogService {
  constructor(private dialog: MatDialog) {}

  private openSide<T, D = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    data: { item?: Partial<DiscountCode> }
  ): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data,
      panelClass: ['modal', 'side-modal-lg', 'modal-owner-details', 'right'],
    }

    const dialogRef = this.dialog.open(componentOrTemplateRef, defaultConfig)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }

  open(data: { item?: Partial<DiscountCode> }) {
    return this.openSide(DiscountCodeDialogComponent, data)
  }
}
